import { render, staticRenderFns } from "./LeadGiverIcon.vue?vue&type=template&id=22310b28&scoped=true&"
import script from "./LeadGiverIcon.vue?vue&type=script&lang=js&"
export * from "./LeadGiverIcon.vue?vue&type=script&lang=js&"
import style0 from "./LeadGiverIcon.vue?vue&type=style&index=0&id=22310b28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22310b28",
  null
  
)

export default component.exports